import styles from './MainBanner.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import SwiperCore from 'swiper';
import { useEffect, useState } from 'react';
import banner1 from '../../assets/banner/mainBanner01.jpg';
import banner3 from '../../assets/banner/mainBanner03.jpg';
import banner4 from '../../assets/banner/mainBanner04.jpg';
import banner5 from '../../assets/banner/mainBanner05.jpg';
import banner6 from '../../assets/banner/mainBanner06.jpg';
import banner7 from '../../assets/banner/mainBanner07.jpg';
import banner10 from '../../assets/banner/mainBanner10.jpeg';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../libs/axiosClient';
import { useQuery } from 'react-query';
// Fallback banner data
const defaultBannerList: IBannerType[] = [
  { image: banner10, url: 'productDetail/30011' },
];

export interface IBannerType {
  image: string;
  url?: string;
}
function MainBanner() {
  const [activeIdx, setActiveIdx] = useState(0);
  const [swiper, setSwiper] = useState<SwiperCore>();
  const navigate = useNavigate();
  const { data: apiBannerData, isLoading } = useQuery<IBannerType[]>(
      'banner-advertisement',
      async () => {
        return await axiosClient
            .get('/data/banner/advertisement')
            .then((res) =>
                res.data.map((banner: any) => ({
                  image: banner.image,
                  url: banner.link
                }))
            );
      },
      {
        staleTime: 60000 * 60, // 1 hour cache
      }
  );

  // Don't show anything while loading, only show default if API fails or returns empty
  const slideList = isLoading ? [] : (apiBannerData && apiBannerData.length > 0 ? apiBannerData : defaultBannerList);

  // Don't render anything while loading
  if (isLoading) {
    return <div className={styles.container}></div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.bannerSliderWrap}>
        <Swiper
          onSwiper={setSwiper}
          slidesPerView={1}
          spaceBetween={0}
          className={styles.bannerSlider}
          onSlideChange={(e) => setActiveIdx(e.activeIndex)}
        >
          {slideList.map((slide, idx) => (
            <SwiperSlide
              key={idx}
              onClick={() => {
                if (slide.url) navigate(slide.url);
              }}
            >
              <img
                src={slide.image}
                alt="banner"
                style={{ cursor: slide.url ? 'pointer' : 'unset' }}
              />
            </SwiperSlide>
          ))}
          {/* <SwiperSlide>
            <img src={banner3} alt="banner" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={banner2} alt="banner" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={banner} alt="banner" />
          </SwiperSlide> */}
        </Swiper>
        {slideList.length > 1 && (
          <ul className={styles.paginationWrap}>
            {slideList.map((banner, idx) => (
              <li
                key={idx}
                onClick={() => swiper?.slideTo(idx, 200)}
                className={idx === activeIdx ? styles.hit : ''}
              ></li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
export default MainBanner;
